/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "追加"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "すべて削除"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var jaJP = Object.assign(TranslationProviderComponent, {
  translations
});

export { jaJP as j };
//# sourceMappingURL=ja-JP-CdhJHumO.js.map
